import { schema } from 'normalizr';
import paginateAction from '@utils/paginateAction';
import { authTypes } from '../constants';
import { meSchema, topologySchema, paginatorListSchema } from '../schemas';

const host = `${process.env.BACKEND_URL}`;

const config = {
  apiClientId: 'T6kXrYaPUVd1MpheMQ9hbLmyjspAsF0cDk5Dzjj2',
  apiClientSecret:
    's50mFdHEjxsrTy74c7FPVaNE8uc7lKcWvLejWvIg7pYAlqxfJb5D3VL3yTvLUUuNbzwTP56QNf1DzKhbbXZKsKAAh7iwwnDL1glzy19FE14Wa5f2zkb6bOD5kCT2ih8j'
};

export const setDarkMode = (isDarkModeOn) => ({
  type: authTypes.SET_DARK_MODE,
  isDarkModeOn
});

export const authenticate = ({ accessToken, refreshToken }) => ({
  type: authTypes.AUTHENTICATE,
  payload: { accessToken, refreshToken }
});

export const reauthenticate = ({ accessToken, refreshToken }) => ({
  type: authTypes.AUTHENTICATE,
  payload: { accessToken, refreshToken }
});

export const setSelectedGoal = (selectedGoal) => ({
  type: authTypes.SELECTED_GOAL,
  selectedGoal
});

export const setSelectedNav = (selectedNav) => ({
  type: authTypes.SELECTED_NAV,
  selectedNav
});

export const showFollowGoalTooltip = (show) => ({
  type: authTypes.SHOW_FOLLOW_GOAL_TOOLTIP,
  show
});

export const showSwitchGoalTooltip = (show) => ({
  type: authTypes.SHOW_SWITCH_GOAL_TOOLTIP,
  show
});

export const toggleLoginModal = (show, loginType = 'login') => ({
  type: authTypes.LOGIN_MODAL,
  show,
  loginType
});

export const deauthenticate = () => ({ type: authTypes.DEAUTHENTICATE });

export const hideNudge = () => ({ type: authTypes.HIDE_NUDGE });

export const fetchMyInfo = () => (dispatch) =>
  dispatch({
    type: authTypes.ME,
    endpoint: 'v1/user/me/',
    method: 'get',
    schema: meSchema
  });

export const fetchFollowedGoals = () => (dispatch) =>
  dispatch({
    type: authTypes.FOLLOWED_GOALS,
    endpoint: 'v1/user/me/pinned_topology/?subscribed_goals=true',
    method: 'get',
    schema: [{ topology: topologySchema }],
    entityType: 'topology',
    processData: (data) =>
      data.map((resultItem) => ({
        ...resultItem,
        slug: resultItem.relative_link?.split('/')[2]
      }))
  });

export const dailyTaskStatus = () => (dispatch) =>
  dispatch({
    type: authTypes.DAILY_TASK,
    endpoint: 'v1/gamification/daily_task/status/',
    method: 'get'
  });

export const followGoal = (uid, isFollow) => (dispatch) =>
  dispatch({
    type: authTypes.FOLLOW_GOAL,
    endpoint: `v1/topology/users/${uid}/${isFollow ? 'pin' : 'unpin'}/`,
    method: 'post'
  });

export const fetchCountries = () => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_COUNTRIES,
    endpoint: 'v2/internationalization/countries/',
    method: 'get'
  });

// export const fetchStates = (countryCode) => (dispatch) =>
//   dispatch({
//     type: authTypes.FETCH_STATES,
//     endpoint: `v1/internationalization/states/?country_code=${countryCode}`,
//     method: 'get'
//   });

export const fetchStates = () => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_STATES,
    endpoint: 'api/states',
    method: 'get',
    isCMS: true
  });

export const fetchCredentials = () => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_CREDENTIALS,
    endpoint: 'v1/user/me/credentials',
    method: 'get'
  });

export const fetchBioRecommendation = () => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_BIO_RECOMMENDATION,
    endpoint: 'v1/user/me/bio_recommendation',
    method: 'get'
  });

export const resetOtpResponse = () => ({
  type: authTypes.RESET_OTP_RESPONSE
});

export const resetVerifyOtpResponse = () => ({
  type: authTypes.RESET_VERIFY_OTP_RESPONSE
});

export const sendOtpOrEmail = (
  phone,
  countryCode,
  otpType,
  email = '',
  for_classroom = false
) => (dispatch) =>
  dispatch({
    type: authTypes.RESEND_OTP,
    endpoint: 'v3/user/user_check/',
    method: 'post',
    data: {
      phone,
      country_code: countryCode,
      otp_type: otpType,
      email,
      send_otp: true,
      is_un_teach_user: for_classroom
    }
  });

export const latestStreakDetail = () => (dispatch) =>
  dispatch({
    type: authTypes.LATEST_STREAK,
    endpoint: 'v1/gamification/latest_streak/detail/',
    method: 'get'
  });

export const login = (
  email,
  phone,
  otp,
  countryCode,
  backend,
  firstName,
  lastName,
  state,
  password,
  register,
  for_classroom = false,
  code = ''
) => (dispatch) =>
  dispatch({
    type: authTypes.LOGIN,
    endpoint: 'v1/user/login/',
    method: 'post',
    data: {
      backend,
      phone,
      otp,
      client_id: config.apiClientId,
      client_secret: config.apiClientSecret,
      country_code: countryCode,
      email,
      first_name: firstName,
      last_name: lastName,
      state,
      password,
      register,
      user_info: true,
      is_un_teach_user: for_classroom,
      un_teach_institue_code: code
    }
  });

export const verifyPhone = (phone, countryCode, otpType) => (dispatch) =>
  dispatch({
    type: authTypes.VERIFY_PHONE,
    endpoint: 'v1/user/me/verify_phone_otp/',
    method: 'post',
    data: {
      phone,
      country_code: countryCode,
      otp_type: otpType
    }
  });

export const verifyOtp = (phone, otp) => (dispatch) =>
  dispatch({
    type: authTypes.VERIFY_OTP,
    endpoint: 'v1/user/me/verify_phone/',
    method: 'post',
    data: {
      phone,
      otp
    }
  });

export const updateUser = (payload) => (dispatch) =>
  dispatch({
    type: authTypes.UPDATE_USER,
    endpoint: 'v1/user/update/',
    method: 'post',
    data: payload
  });

export const updateCredentials = (payload) => (dispatch) =>
  dispatch({
    type: authTypes.UPDATE_CREDENTIALS,
    endpoint: 'v1/user/me/credentials/',
    method: 'post',
    data: payload
  });

export const unlockFreePlan = (payload) => ({
  type: authTypes.UNLOCK_FREE_PLAN,
  endpoint: 'v1/uplus/platform/unlock/',
  method: 'post',
  data: payload
});

export const resetNetworkCallsError = () => ({
  type: authTypes.RESET_NETWORK_CALLS_ERROR
});

export const sendMailOtp = (email) => (dispatch) =>
  dispatch({
    type: authTypes.SEND_MAIL_OTP,
    endpoint: 'v1/user/send_mail_otp/',
    method: 'post',
    data: { email }
  });

export const verifyMailOtp = (email, otp) => (dispatch) =>
  dispatch({
    type: authTypes.VERIFY_MAIL_OTP,
    endpoint: 'v1/user/verify_mail_otp/',
    method: 'post',
    data: { email, otp }
  });

export const sendMobileOtp = (phone, countryCode) => (dispatch) =>
  dispatch({
    type: authTypes.SEND_MOBILE_OTP,
    endpoint: 'v1/user/me/verify_phone_otp/',
    method: 'post',
    data: { phone, country_code: countryCode, otp_type: 1 }
  });

export const verifyMobileOtp = (phone, otp) => (dispatch) =>
  dispatch({
    type: authTypes.VERIFY_MOBILE_OTP,
    endpoint: 'v1/user/me/verify_phone/',
    method: 'post',
    data: { phone, otp }
  });

export const fetchFeedbackOptions = (goalUID) => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_FEEDBACK_OPTIONS,
    endpoint: `v1/feedback/plus_subscription/?object_uid=${goalUID}`,
    method: 'get',
    schema: new schema.Object({})
  });

export const submitSubscriptionFeedback = (data, uid, extraData) => ({
  type: authTypes.SUBMIT_FEEDBACK,
  endpoint: `v1/feedback/${uid}/response/`,
  method: 'post',
  data,
  ...extraData
});

export const updateAvatar = (newAvatar) => (dispatch) =>
  dispatch({
    type: authTypes.UPDATE_AVATAR,
    endpoint: 'v1/user/update-avatar/',
    method: 'put',
    data: { avatar: newAvatar }
  });

export const fetchRenewalTouchPoint = (goalUID) => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_RENEWAL_TOUCHPOINT_DATA,
    endpoint: `v1/subscriptions/suggested_renew_referral_code/?goal_uid=${goalUID}`,
    method: 'get',
    goalUID,
    schema: new schema.Object({}),
    processData: (data) => ({
      percentage: data.percentage,
      code: data.code,
      show: data.show,
      maxDiscount: data.max_discount,
      validTill: data.valid_till,
      daysRemaining: data.days_remaining
    })
  });

export const logout = () => (dispatch) =>
  dispatch({
    type: 'LOGOUT',
    endpoint: 'v1/user/logout/',
    method: 'post'
  });

export const fetchSettingsManageUpdates = () => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_SETTINGS_MANAGE_UPDATES,
    endpoint: 'v1/move/preferences',
    method: 'get',
    schema: new schema.Object({}),
    processData: (data) => {
      const newData = {};
      data.forEach((resultItem) => {
        newData[resultItem.meta.key] = resultItem;
      });

      return newData;
    }
  });

export const fetchReferralDetails = () => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_REFERRAL_DETAILS,
    endpoint: 'v1/subscriptions/referrals/referral_details/',
    method: 'get',
    schema: new schema.Object({})
  });

const getReferralsAction = () => (next) => ({
  type: authTypes.FETCH_REFERRAL_LIST,
  endpoint: next,
  method: 'get',
  key: 'referrals',
  schema: paginatorListSchema
});

export const fetchReferrals = (nextPage, resetWithoutEmpty = false) =>
  paginateAction(
    'v1/subscriptions/referrals/?limit=30',
    getReferralsAction(),
    'referralList',
    'referrals',
    resetWithoutEmpty
  )(nextPage);

export const changeManageUpdatePreferencesV2 = (blockType, key, flag) => ({
  type: authTypes.CHANGE_MANAGE_UPDATE_PREFERENCES,
  endpoint: 'v1/move/preferences',
  method: 'post',
  data: {
    type: blockType,
    channel: key,
    is_enabled: flag
  },
  blockType,
  key,
  flag
});

export const fetchNewToken = (refreshToken) => {
  const url = `${host}v1/oauth2/token/`;
  return fetch(url, {
    method: 'POST',
    body: new URLSearchParams(
      `grant_type=refresh_token&refresh_token=${refreshToken}&client_id=${config.apiClientId}&client_secret=${config.apiClientSecret}`
    ),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

export const fetchAccessControl = (goalUID) => (dispatch) =>
  dispatch({
    type: authTypes.ME_ACCESS_CONTROL,
    endpoint: `v1/user/me/access_control/?goal_uid=${goalUID}`,
    method: 'get',
    key: goalUID
  });

export const fetchIntercomToken = (isPlusUser, isEducator) => (dispatch) =>
  dispatch({
    type: authTypes.FETCH_INTERCOM_TOKEN,
    endpoint: isEducator
      ? 'v1/user/me/intercom_token/?platform=0'
      : `v1/user/me/intercom_token/?platform=0&plus_sales=${
          isPlusUser ? 0 : 1
        }&plus_subscription=${isPlusUser ? 1 : 0}`,
    method: 'get'
  });

export const setPrePaymentSubscriptionUids = (uids) => ({
  type: authTypes.PRE_PAYMENT_PLUS_SUBSCRIPTION_UIDS,
  uids
});

export const toggleSiteWideReferralBanner = (show = false) => ({
  type: authTypes.HIDE_REFERRAL_BANNER,
  show
});

export const createCustomCode = (goalUID, suffix) => ({
  type: authTypes.GENERATE_CUSTOM_CODE,
  endpoint: 'v1/subscriptions/referral_code/create_variable/',
  method: 'post',
  data: {
    goal_uid: goalUID,
    campaign_display_name: suffix
  }
});

export const getCustomCodeData = (suffix) => ({
  type: authTypes.GET_CUSTOM_CODE_DATA,
  endpoint: `v1/subscriptions/referral_code/custom_code_details/?campaign_display_name=${suffix}`,
  method: 'get'
});
